import React, { memo } from "react";
import { Button } from "@chakra-ui/react";


export const CustomerPostScoreBtn: React.FC<{isSubmitting: boolean, text: string}> = memo(({isSubmitting, text}) => {
  return (
    <Button
      colorScheme="blue"
      w='75%'
      size='lg'
      type='submit'
      isLoading={isSubmitting}
      isDisabled={isSubmitting}
      loadingText="送信中"
    >
      {text}
    </Button>
  );
});